import { FeatureToggleClientService } from 'feature-toggle-client';
const ticketHistoryKey = 'download-ticket-history';
const usingStartsWithOnContactsSearch = 'using-starts-with-on-contacts-search';
const searchCustomerOnDemandTyping = 'filter-customer-on-demand-typing';
const showingContactsLastInteraction = 'showing-contacts-last-interaction';
const hidingTestUserCheckbox = 'hide-test-user-checkbox';
const contactTaxDocument = 'contact-tax-document';
const disableGetRepliedMessageById = 'disable-get-replied-message-by-id';
const showingActiveMessageTemplateContent = 'desk-show-template-content';
const ticketLink = 'desk-ticket-link';
const reactEnabledForContactsPage = 'enable-react-contacts-page';
export class UserFeatures {
    static downloadTicketHistoryEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ticketHistoryKey);
    }
    static isUsingStartsWithOnContactsSearch() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(usingStartsWithOnContactsSearch);
    }
    static isShowingContactsLastInteraction() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(showingContactsLastInteraction);
    }
    static isHidingTestUserCheckbox() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(hidingTestUserCheckbox);
    }
    static isContactTaxDocumentEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(contactTaxDocument);
    }
    static isSearchCustomerOnDemandTyping() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(searchCustomerOnDemandTyping);
    }
    static isDisableGetRepliedMessageById() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(disableGetRepliedMessageById);
    }
    static isShowingActiveMessageTemplateContent() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(showingActiveMessageTemplateContent);
    }
    static isTicketLinkEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ticketLink);
    }
    static isReactOnContactsPageEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(reactEnabledForContactsPage);
    }
}
